import React, { useMemo } from "react";
import { renderToString } from "react-dom/server";
import { useTheme } from "@mui/material";
import { AssetsChartTag } from "@components/Chart/AssetsChart/AssetsChartTag";
import { AssetsChartDataName } from "@components/Chart/AssetsChart";
import { DonutChartItem } from "./DonutChart";

export const useChartOptions = (
  width: number,
  height: number,
  chartColors: string[] | undefined,
  chartData: DonutChartItem[] | undefined
): Highcharts.Options => {
  const theme = useTheme();
  return useMemo(() => {
    return {
      title: {
        text: "",
      },
      credits: {
        enabled: false,
      },
      chart: {
        backgroundColor: "transparent",
        plotBackgroundColor: "transparent",
        plotShadow: false,
        type: "pie",
        width,
        height,
      },
      colors: chartColors || [],
      tooltip: {
        formatter: () => false,
      },
      plotOptions: {
        pie: {
          allowPointSelect: false,
          cursor: "pointer",
          borderWidth: 0,
          borderRadius: 0,
          size: "100%",
          innerSize: "35%",
          dataLabels: {
            enabled: true,
            useHTML: true,
            distance: -30,
            style: {
              color: theme.palette.text.primary,
              fontFamily: theme.typography.fontFamily,
              fontSize: theme.typography.caption.fontSize as string,
              fontWeight: "400",
              lineHeight: "18px",
            },
            formatter: function () {
              const percentage = this.point.percentage;
              const name = this.point.name;
              if (!percentage || !name) return;

              return renderToString(
                <AssetsChartTag
                  percent={percentage}
                  name={name as AssetsChartDataName}
                  theme={theme}
                />
              );
            },
          },
        },
      },
      series: [
        {
          colorByPoint: true,
          data: chartData,
          type: "pie",
        },
      ],
    };
  }, [width, height, chartColors, chartData, theme]);
};
